const baseStyleContainer = {
    bg: "primary.700",
    color: "white",
};
const baseStyle = {
    container: baseStyleContainer,
};
const getSize = (size) => ({
    container: {
        width: size,
        height: size,
        fontSize: `calc(${size} / 2)`,
    },
    excessLabel: {
        width: size,
        height: size,
    },
    label: {
        fontSize: `calc(${size} / 2)`,
        lineHeight: size !== "100%" ? size : undefined,
    },
});
const sizes = {
    xs: getSize("24px"),
    sm: getSize("28px"),
    md: getSize("32px"),
    lg: getSize("40px"),
    xl: getSize("48px"),
};
const defaultProps = {
    size: "xl",
};
const Avatar = {
    baseStyle,
    sizes,
    defaultProps,
};
export default Avatar;
